import { type CustomFeature, FeatureType, LinkTarget } from '@types';

const linkDefault: {
  linkTitle: string;
  linkUrl: string;
  openMethod: LinkTarget;
} = {
  linkTitle: '',
  linkUrl: '',
  openMethod: LinkTarget.blank,
};

function customButtonDefault(type: FeatureType): CustomFeature {
  switch (type) {
    case FeatureType.link:
      return {
        code: FeatureType.link,
        title: '',
        linkUrl: linkDefault.linkUrl,
        openMethod: linkDefault.openMethod,
        openStyle: 1,
        turnOffBgMusicWhenLayerOpen: 0,
        turnOffBgVoiceWhenLayerOpen: 0,
      };
    case FeatureType.mobile:
      return {
        code: FeatureType.mobile,
        title: '',
        mobiles: [],
      };
    case FeatureType.map:
      return {
        code: FeatureType.map,
        title: '',
        location: {},
      };
    case FeatureType.media:
      return {
        code: FeatureType.media,
        title: '',
        imgs: [],
        musicMediaId: 0,
        musicMediaUrl: '',
        musicMediaName: '',
        musicVolume: 1,
        musicLoop: 1,
        turnOffBgMusicOnPlay: 0,
        turnOffBgVoiceOnPlay: 0,
        layoutStyle: 0,
        turnOffRotateOnPlay: 0,
        ...linkDefault,
      };
    case FeatureType.text:
      return {
        code: FeatureType.text,
        title: '',
        content: '',
        ...linkDefault,
      };
    case FeatureType.article:
      return {
        code: FeatureType.article,
        title: '',
        articles: [],
        turnOffBgMusicOnPlay: 0,
        turnOffBgVoiceOnPlay: 0,
        openStyle: 1,
      };
    case FeatureType.audio:
      return {
        code: FeatureType.audio,
        title: '',
        musicMediaId: 0,
        musicMediaUrl: '',
        musicMediaName: '',
        musicVolume: 1,
        musicLoop: 1,
        turnOffBgMusicOnPlay: 0,
        turnOffBgVoiceOnPlay: 0,
        turnOffRotateOnPlay: 0,
      };
    case FeatureType.video:
      return {
        code: FeatureType.video,
        title: '',
        videos: [],
        iframeVideo: '',
        turnOffBgMusicOnPlay: 1,
        turnOffBgVoiceOnPlay: 1,
        layoutStyle: 0,
        ...linkDefault,
      };
    case FeatureType.seqFrame:
      return {
        code: FeatureType.seqFrame,
        title: '',
        imgs: {},
        content: '',
        playMethod: 2,
        playSpeed: 24,
        ...linkDefault,
      };
    case FeatureType.scene:
      return {
        code: FeatureType.scene,
        title: '',
        sceneId: 0,
      };
    case FeatureType.noFunc:
      return {
        code: FeatureType.noFunc,
        title: '',
      };
    case FeatureType.event:
      return {
        code: FeatureType.event,
        title: '',
        scriptStr: '',
      };
    case FeatureType.miniProgram:
      return {
        code: FeatureType.miniProgram,
        title: '',
        id: '',
        url: '',
      };

    case FeatureType.doc:
      return {
        code: FeatureType.doc,
        title: '',
        docs: [],
        openStyle: 1,
      };
    case FeatureType.model3d:
      return {
        code: FeatureType.model3d,
        title: '',
        modelTids: [],
        turnOffBgMusicOnPlay: 0,
        displayStyle: 0,
      };
    case FeatureType.prevScene:
      return {
        code: FeatureType.prevScene,
        title: '',
        skipThumbHidden: 1,
        stopInLast: 0,
      };
    case FeatureType.nextScene:
      return {
        code: FeatureType.nextScene,
        title: '',
        skipThumbHidden: 1,
        stopInLast: 0,
      };
    default:
      return {
        code: FeatureType.noFunc,
        title: '',
      };
  }
}

export default customButtonDefault;
